import { TextField, InputAdornment, IconButton, FormControl, FormHelperText, Typography } from '@mui/material';
import UploadIcon from '@mui/icons-material/Upload';
import { useRef } from 'react';
import { TramRounded } from '@mui/icons-material';

const FileUpload = (props) => {
    const {
        controleId,
        comp,
        stateData: data,
        stateErrors: errors,
        isDisabled,
        onFileChange,
    } = props;

    const fileRef = useRef();

    return <>
        {/* <div className={`form-group ${comp.isRequired && "required"}`}>
            <label className="form-control-label" htmlFor={controleId}>
                {comp.label}
            </label>
            <br />
            <div className="custom-file">
                <input
                    type="file"
                    className="custom-file-input"
                    id={controleId}
                    name={controleId}
                    disabled={isDisabled}
                    aria-label={comp.label}
                    onChange={onFileChange}
                />
                <label className="custom-file-label" htmlFor={controleId}>
                    {data[controleId] === undefined
                        ? "Select file"
                        : data[controleId]}
                </label>
            </div>
        </div> */}
        <FormControl fullWidth variant="outlined" error={errors[controleId] ? true : false}>
            <Typography variant="body1" sx={{ mb: 1 }}>
                {comp.label} {comp.isRequired && <span style={{ color: 'red' }}>*</span>}
            </Typography>
            <input
                name={controleId}
                type="file"
                ref={fileRef}
                style={{ display: 'none' }}
                onChange={onFileChange}
            />
            <TextField
                variant="outlined"
                //label={!data[controleId] ? "Choose a file" : data[controleId]}
                placeholder={!data[controleId] ? "Choose a file" : data[controleId]}
                disabled={isDisabled}
                InputProps={{
                    readOnly: true,
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton onClick={() => fileRef.current.click()}>
                                <UploadIcon />
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
                onClick={() => fileRef.current.click()}
            />
            {errors[controleId] && <FormHelperText>{errors[controleId]}</FormHelperText>}
        </FormControl>
    </>
}

export default FileUpload;